module.exports = __webpack_public_path__ + "static/media/pencil.c85850fa.svg";